import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { RiHomeHeartFill } from 'react-icons/ri';
import { IoIosArrowForward } from 'react-icons/io';
import logo from '../assets/chirp-logo.png';
import { categories } from '../utils/data';

const isNotActiveStyle = 'flex items-center pl-5 gap-3 text-white hover:text-[#8A0303] transition-all duration-200 ease-in-out capitalize';
const isActiveStyle = 'flex items-center pl-5 gap-3 font-extrabold text-[#00FF00] border-r-2 border-black transition-all duration-200 ease-in-out capitalize';





const Sidebar = ({ user, closeToggle }) => {
  const [isKingPinsOpen, setIsKingPinsOpen] = useState(false);

  const handleCloseSidebar = () => {
    if (closeToggle) closeToggle(false);
  };

  const toggleKingPins = () => {
    setIsKingPinsOpen(!isKingPinsOpen);
  };

  return (
    <div className="flex flex-col justify-between bg-sidebar h-full overflow-y-scroll min-w-210 hide-scrollbar">
      <div className="flex flex-col">
        <Link
          to="/"
          className="flex pl-5 gap-2 my-6 pt-1 w-190 items-center"
          onClick={handleCloseSidebar}
        >
          <img src={logo} alt="logo" className="w-full" />
        </Link>
        <div className="flex flex-col gap-3">

          <NavLink
            to="/"
            className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
            onClick={handleCloseSidebar}
          >
            <RiHomeHeartFill size={30} color="#8A0303" />
            <span className="text-lg p-5">House</span>
          </NavLink>

          <h3
            className="mt-2 pl-6 text-lg cursor-pointer"
            onClick={toggleKingPins}
          >
            King Pins
            <IoIosArrowForward
              className={`transform transition-transform duration-200 ${
                isKingPinsOpen ? 'rotate-90' : ''
              }`}
            />
          </h3>

          {isKingPinsOpen && (
            <div className="pl-0">
              {categories.slice(0, categories.length - 1).map((category) => (
                <NavLink
                  to={`/category/${category.name}`}
                  className={({ isActive }) => (isActive ? isActiveStyle : isNotActiveStyle)}
                  onClick={handleCloseSidebar}
                  key={category.name}
                  style={{ color: category.color }}
                >
                  <img src={category.image} className="w-8 h-8 rounded-full shadow-sm" alt={category.name} />
                  <span className="text-lg pl-6">{category.name}</span>
                </NavLink>
              ))}
            </div>
          )}
        </div>
      </div>
      {user && (
        <Link
          to={`user-profile/${user._id}`}
          className="flex my-6 mb-3 gap-2 p-2 items-center bg-white rounded-lg shadow-lg mx-3"
          onClick={handleCloseSidebar}
        >
          <img src={user.image} className="w-10 h-10 rounded-full" alt="" />
          <p>{user.userName}</p>
        </Link>
      )}
    </div>
  );
};

export default Sidebar;
